import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { CommonUtil } from '../../utils/commonUtil';

const PerformanceCheckSendSmsDialog = ({
  visible,
  sending = false,
  initialData,
  onHide,
  onSend,
}) => {
  const [destAddr, setDestAddr] = useState('');
  const [sourceAddr, setSourceAddr] = useState('');
  const [contents, setContents] = useState('');

  useEffect(() => {
    if (!visible || !initialData) return;
    setDestAddr(initialData.destAddr || '');
    setSourceAddr(initialData.sourceAddr || '');
    setContents(initialData.contents || '');
  }, [visible, initialData]);

  const remain = 90 - (contents || '').length;

  return (
    <Dialog
      modal
      visible={visible}
      style={{ width: '28rem' }}
      header="성능점검 완료 문자 전송"
      onHide={onHide}
      footer={() => (
        <div className="flex justify-content-end gap-2">
          <Button
            label="취소"
            className="p-button-text"
            disabled={sending}
            onClick={onHide}
          />
          <Button
            label="전송하기"
            icon="pi pi-send"
            loading={sending}
            onClick={() =>
              onSend({
                shopId: initialData?.shopId,
                destAddr,
                sourceAddr,
                contents,
              })
            }
          />
        </div>
      )}
    >
      <div className="mb-2">
        딜러 : {initialData?.customerName || '-'}
      </div>
      <div className="flex align-items-center mb-2">
        <label className="white-space-nowrap mr-2">수신번호</label>
        <InputText
          className="w-full p-inputtext-sm"
          value={CommonUtil.Formatter.phone(destAddr) || destAddr}
          disabled={sending}
          onChange={(e) => setDestAddr(e.target.value)}
        />
      </div>
      <div className="flex align-items-center mb-2">
        <label className="white-space-nowrap mr-2">발신번호</label>
        <InputText
          className="w-full p-inputtext-sm"
          value={CommonUtil.Formatter.phone(sourceAddr) || sourceAddr}
          readOnly
          disabled={sending}
        />
      </div>
      <div className="mb-1">내용 ({remain}자 남음)</div>
      <InputTextarea
        className="w-full"
        rows={4}
        maxLength={90}
        value={contents}
        disabled={sending}
        onChange={(e) => setContents(e.target.value)}
      />
    </Dialog>
  );
};

export default PerformanceCheckSendSmsDialog;
